export const steps = [
    { key: 1, title: "Podstrona" },
    { key: 2, title: "Operacja" },
    { key: 3, title: "Treść" },
];

export const operations = [
    { label: "Prześlij", value: '1' },
    { label: "Modyfikuj", value: '2' },
];